import { Component } from "vue-property-decorator";
import Vue from "vue";

import { namespace } from 'vuex-class';
const WareInfo = namespace('WareInfo');

import { AxiosRequestConfig, Method } from 'axios';

@Component({

})
export default class VueHoduCommon extends Vue {
    FeaturesTab : any = { 
        CALENDAR         : 'calendar'        , SCHEDULE : 'schedule', TODO         : 'todo'        ,  
        GROUP_AND_TEAM   : 'group_and_team'  , CARD     : 'card'    , NOTIFICATION : 'notification', 
        FILE             : 'file'            , WORK     : 'work'    , CHATTING     : 'chatting'    ,
        VIDEO_CONFERENCE : 'video_conference', APPROVAL : 'approval', ATTEND       : 'attend'      ,
    };

    ManualTab : any = { 
        CALENDAR : 'calendar', SCHEDULE     : 'schedule'    , GROUP_AND_TEAM   : 'group_and_team',
        CARD     : 'card'    , NOTIFICATION : 'notification', FILE             : 'file'          , 
        WORK     : 'work'    , CHATTING     : 'chatting'    , VIDEO_CONFERENCE : 'video_conference',
        ETC      : 'etc'     ,
    };

    ServiceCenterTab : any = {
        QNA : 'QnA', QUESTION : 'question'
    }

    /**
     * @WareInfo.State
     */
    @WareInfo.State features_tab       !: string;
    @WareInfo.State manual_tab         !: string;
    @WareInfo.State service_center_tab !: string;

    /**
     * @WareInfo.Action
     */
    @WareInfo.Action doSetFeaturesTab      ?: any;
    @WareInfo.Action doSetManualTab        ?: any;
    @WareInfo.Action doSetServiceCenterTab ?: any;

    is_mobile : boolean = false;

    mounted() : void {
        // @ts-ignore
        if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) 
            || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(navigator.userAgent.substr(0,4))) { 
            this.is_mobile = true;
        }
    }

    /**
     * API 호출
     * @param  {string} url     : url
     * @param  {Method} method  : get, post, put, delete 등
     * @param  {any}    body   ?: parameter
     */
    async hodu_api_call(url : string, method : Method, body ?: any) : Promise<any> {

        return new Promise((resolve, reject) => {
            let config : AxiosRequestConfig = {
                url: url,
                method: method,
                data: body
            }

            this.$http.request(config)
            .then(async(response) => {
                resolve(response);
            })
            .catch(async(e) => {
                reject(e);
            });
        })
    }

    /**
     * 날짜 형식 맞춰서 넘기기
     */
    getDateFormat(date : Date | string) : string {
        const target_date : Date = typeof date == 'string' ? new Date(date) : date;

        const year  : string = `${target_date.getFullYear()}`;
        const month : string = `0${target_date.getMonth() + 1}`.slice(-2);
        const day   : string = `0${target_date.getDate()}`.slice(-2);

        return `${year}.${month}.${day}`;
    }

    /**
     * OS 정보 받아오기
     */
    async getOSInfo() : Promise<string> {
        try {
            const ua = navigator.userAgent;
            let os : string = "";
            if (ua.match(/Win(dows )?NT 6\.0/)) {
                os = "Windows Vista";
            } else if (ua.match(/Win(dows )?(NT 5\.1|XP)/)) {
                os = "Windows XP";
            } else {
                if ((ua.indexOf("Windows NT 5.1") != -1) || (ua.indexOf("Windows XP") != -1)) { os = "Windows XP"; } 
                else if ((ua.indexOf("Windows NT 7.0") != -1) || (ua.indexOf("Windows NT 6.1") != -1)) { os = "Windows 7"; } 
                else if ((ua.indexOf("Windows NT 8.0") != -1) || (ua.indexOf("Windows NT 6.2") != -1)) { os = "Windows 8"; } 
                else if ((ua.indexOf("Windows NT 8.1") != -1) || (ua.indexOf("Windows NT 6.3") != -1)) { os = "Windows 8.1"; } 
                else if ((ua.indexOf("Windows NT 10.0") != -1) || (ua.indexOf("Windows NT 6.4") != -1)) { os = "Windows 10"; } 
                else if ((ua.indexOf("iPad") != -1) || (ua.indexOf("iPhone") != -1) || (ua.indexOf("iPod") != -1)) { os = "Apple iOS"; } 
                else if (ua.indexOf("Android") != -1) { os = "Android OS"; } 
                else if (ua.match(/Win(dows )?NT( 4\.0)?/)) { os = "Windows NT"; } 
                else if (ua.match(/Mac|PPC/)) { os = "Mac OS"; } 
                else if (ua.match(/Linux/)) { os = "Linux"; } 
                else if (ua.match(/(Free|Net|Open)BSD/)) { os = RegExp.$1 + "BSD"; } 
                else if (ua.match(/SunOS/)) { os = "Solaris"; }
            }

            if (os.indexOf("Windows") != -1) {
                if (navigator.userAgent.indexOf('WOW64') > -1 || navigator.userAgent.indexOf('Win64') > -1) { os += ' 64bit'; } 
                else { os += ' 32bit'; }
            }

            return os;

        } catch(e) {
            return '상정되지 않은 OS';
        }
    }

    /**
     * 브라우저 정보 받아오기
     */
    async getBrowserInfo() : Promise<string> {

        const agent : string = navigator.userAgent.toLowerCase();
        let version : number | undefined;

        try {
            // @ts-ignore Opera 8.0+
            const isOpera = (!!window['opr'] && !!opr['addons']) || !!window['opera'] || navigator.userAgent.indexOf(' OPR/') >= 0;

            // @ts-ignore Firefox 1.0+
            const isFirefox = typeof InstallTrigger !== 'undefined';

            // @ts-ignore Safari 3.0+ "[object HTMLElementConstructor]" 
            const isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && safari['pushNotification']));

            // Internet Explorer 6-11
            const isIE = /*@cc_on!@*/false || !!document['documentMode'];

            // Edge 20+
            const isEdge = !isIE && !!window['StyleMedia'];

            // @ts-ignore Chrome 1 - 71
            const isChrome = !!window['chrome'] && (!!window['chrome']['webstore'] || !!window['chrome']['runtime']);

            // Edge (based on chromium) detection
            const isEdgeChromium = isChrome && (navigator.userAgent.indexOf("Edg") != -1);

            if( isOpera ) {
                const match : RegExpMatchArray | null = navigator.userAgent.match(/OPR\/([0-9]+)\./);
                version = match ? parseInt(match[1]) : undefined;

                return `Opera ${version}`.trim(); 
            }
            else if( isFirefox ) { 
                const match : RegExpMatchArray | null = navigator.userAgent.match(/Firefox\/([0-9]+)\./);
                version = match ? parseInt(match[1]) : undefined;
                return `Firefox ${version}`.trim(); 
            }
            else if( isSafari ) {
                const match : RegExpMatchArray | null = navigator.userAgent.match(/Version\/([0-9]+)\./);
                version = match ? parseInt(match[1]) : undefined; 
                return `Safari ${version}`.trim(); 
            }
            else if( isIE ) {   
                
                let word : string = ''; 

                // IE old version ( IE 10 or Lower ) 
                if ( navigator.appName == "Microsoft Internet Explorer" ) word = "msie "; 

                // IE 11 
                else if ( agent.search( "trident" ) > -1 ) word = "trident/.*rv:"; 

                const reg : RegExp = new RegExp( word + "([0-9]{1,})(\\.{0,}[0-9]{0,1})" ); 
                if ( reg.exec( agent ) != null ) { version = parseFloat( RegExp.$1 + RegExp.$2 ); } 

                return `Internet Explorer ${version ? version : ''}`.trim(); 
            }
            else if( isEdge ) { 
                const match : RegExpMatchArray | null = navigator.userAgent.match(/Edge\/([0-9]+)\./);
                version = match ? parseInt(match[1]) : undefined; 
                return `Microsoft Edge ${version}`; 
            }
            else if( isChrome && !isEdgeChromium ) { 
                
                let raw : RegExpMatchArray | null = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
                version = raw ? parseInt(raw[2], 10) : undefined;

                return `Google Chrome ${version ? version : ''}`.trim(); 
            }
            else if( isEdgeChromium ) {
                const match : RegExpMatchArray | null = navigator.userAgent.match(/Edg\/([0-9]+)\./);
                version = match ? parseInt(match[1]) : undefined;
                
                return `Microsoft Edge Chromium ${version}`; 
            }

            return 'unknown';

        } catch(e) {
            return 'unknown';
        }
    }
}    